export default __webpack_public_path__ + "static/HelveticaNeue-Light-04cd6daa27e6b35b1c2692e69d1d2ca3.woff";